<template>
  <div :class="['content-wrap', containerData.status]">
    <header class="content-header cf">
      <h3>{{ $t('containers.emptyTemplates') }}</h3>
      <div class="header-meta">
        <Link
          :to="`/company/containers/${containerData.uuid}/empty_templates/new`"
          class="button button-green button-small button-round"
          >{{ $t('containers.addEmptyingTemplate') }}</Link
        >
      </div>
    </header>
    <div v-if="containerData.empty_templates && containerData.empty_templates.length > 0" class="content-body">
      <Table>
        <template #header>
          <th>{{ $t('containers.emptyingDates') }}</th>
          <th>
            {{ $t('containers.emptyingDatePosition') }}
          </th>
          <th></th>
        </template>
        <template #body>
          <tr v-for="emptyTemplate in containerData.empty_templates" :key="emptyTemplate.uuid">
            <td>
              <EmptyingTemplateDescription
                :repeatType="emptyTemplate.repeat_type"
                :repeatInterval="emptyTemplate.repeat_interval"
                :referenceDate="emptyTemplate.reference_date"
              />
            </td>
            <td>{{ emptyTemplate.route_position ? emptyTemplate.route_position : $t('meta.notAvailable') }}</td>
            <td class="table__actions">
              <Link :to="`/company/containers/${containerData.uuid}/empty_templates/${emptyTemplate.uuid}`"
                ><span class="material-icons">edit</span></Link
              >
              <button class="table__action-button" @click="deleteEmptyTemplate(emptyTemplate.uuid)">
                <span class="material-icons">delete</span>
              </button>
            </td>
          </tr>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import EmptyingTemplateDescription from '@/components/EmptyingTemplates/Description.vue'
import Table from '@/components/Table/index.vue'

import emptyTemplatesApi from '@/api/emptyTemplates'

export default {
  name: 'CompanyContainerEmptyTemplates',
  inject: ['showPopup'],
  emits: ['refreshData'],
  props: {
    container: {
      type: Object,
      required: true,
    },
  },
  components: {
    EmptyingTemplateDescription,
    Table,
  },
  data() {
    return {
      containerData: this.container,
    }
  },
  watch: {
    container: {
      immediate: true,
      handler(newVal) {
        this.containerData = newVal
      },
      deep: true,
    },
  },
  methods: {
    async deleteEmptyTemplate(templateUuid) {
      if (!(await this.showPopup({ content: this.$t('containers.deleteEmptyTemplateConfirmation'), type: 'confirm' })))
        return

      const result = await emptyTemplatesApi.delete(this.containerData.uuid, templateUuid)
      if (result.success) {
        this.$emit('refreshData')
      }
    },
  },
}
</script>
